<template>
  <div>
    <Head title="Sebaran Berdasarkan Kampus" />
    <!-- FILTER -->
    <div class="w-full mb-8 bg-white rounded-md shadow">
      <div class="w-full p-4 font-semibold bg-gray-200">Filter</div>

      <div class="flex flex-wrap w-full p-6">
        <div class="w-full font-semibold lg:w-3/12">Periode Beasiswa:</div>

        <v-select
          v-model="form.periode"
          :options="periodes"
          class="w-full lg:w-9/12"
          :reduce="p => p.id"
          label="nama"
          placeholder="Pilih Periode"
        />
      </div>
    </div>
    <!-- PANEL TOTAL -->
    <div class="w-full p-4 mb-6 bg-white border rounded shadow">
      <h2 class="mb-2 text-lg font-semibold">Total Kampus</h2>

      <p class="text-sm">
        Total Mahasiswa: <strong>{{ total }}</strong>
      </p>

      <div class="flex flex-wrap gap-3 mt-2 text-sm">
        <span class="px-3 py-1 font-semibold text-white rounded" style="background:#3b82f6">
          Laki-laki: {{ laki }}
        </span>

        <span class="px-3 py-1 font-semibold text-white rounded" style="background:#db2777">
          Perempuan: {{ perempuan }}
        </span>
      </div>
    </div>


    <!-- TABEL -->
    <div class="mb-10 overflow-auto bg-white border rounded shadow">
      <div class="flex justify-end p-3 border-b bg-gray-50">
        <a
          :href="exportUrl"
          class="px-4 py-2 text-sm font-semibold text-white rounded shadow bg-green-600 hover:bg-green-700"
        >
          ⬇ Download Excel
        </a>
      </div>
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-100 border-b">
            <th class="w-12 p-2 text-center border">No</th>
            <th class="p-2 text-left border">Nama Kampus</th>
            <th class="p-2 text-center border">Status</th>
            <th class="p-2 text-center border">Total</th>
            <th class="p-2 text-center text-blue-600 border">Laki-laki</th>
            <th class="p-2 text-center text-pink-600 border">Perempuan</th>
          </tr>
        </thead>


        <tbody>
          <tr
            v-for="(item, i) in report"
            :key="i"
            class="border-b hover:bg-gray-50"
          >
            <td class="p-2 text-center border">
              {{ i + 1 }}
            </td>

            <td class="p-2 font-semibold border">
              <Link
                :href="route('report.universitas.detail', {
                  universitas: item.universitas,
                  periode: form.periode
                })"
                class="text-indigo-600 hover:underline"
              >
                {{ item.universitas }}
              </Link>
            </td>


            <td class="p-2 font-semibold text-center border">
              {{ item.status_universitas }}
            </td>

            <td class="p-2 font-semibold text-center border">
              {{ item.total }}
            </td>

            <td class="p-2 text-center text-blue-600 border">
              {{ item.laki }}
            </td>

            <td class="p-2 text-center text-pink-600 border">
              {{ item.perempuan }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- CHART -->
    <div class="p-4 bg-white rounded shadow">
      <h2 class="mb-4 text-xl font-bold">
        Grafik Sebaran Mahasiswa Berdasarkan Kampus
      </h2>

      <apexchart
        width="100%"
        height="440"
        type="bar"
        :options="chartOptions"
        :series="chartSeries"
      />
    </div>
  </div>
</template>


<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import VueApexCharts from 'vue3-apexcharts'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    Head,
    Link,
    apexchart: VueApexCharts,
  },

  layout: Layout,

  props: {
    report: Array,
    periodes: Array,
    filters: Object,
    laki: Number,
    perempuan: Number,
    total: Number,
  },

  data() {
    return {
      form: {
        periode: parseInt(this.filters.periode) || null,
      },
    }
  },

  computed: {
    exportUrl() {
      const params = new URLSearchParams()
      if (this.form.periode) params.set('periode', this.form.periode)
      return this.route('report.universitas.export') + '?' + params.toString()
    },

    // Chart Data
    univLabels() {
      return this.report.map(r => r.universitas)
    },

    chartSeries() {
      return [
        {
          name: 'Total',
          data: this.report.map(r => r.total),
        },
        {
          name: 'Laki-laki',
          data: this.report.map(r => r.laki),
        },
        {
          name: 'Perempuan',
          data: this.report.map(r => r.perempuan),
        },
      ]
    },

    chartOptions() {
      return {
        chart: { toolbar: { show: false }},
        xaxis: {
          categories: this.univLabels,
          labels: { rotate: -45 },
        },
        dataLabels: { enabled: true },
        colors: ['#3b82f6', '#1d4ed8', '#db2777'],
        legend: { position: 'top' },
      }
    },
  },

  watch: {
    form: {
      handler: throttle(function () {
        const query = pickBy(this.form)

        this.$inertia.get(
          this.route('report.universitas'),
          query,
          {
            preserveState: true,
            preserveScroll: true,
          },
        )
      }, 150),
      deep: true,
    },
  },
}
</script>
